import React from 'react';
import { CircularProgress, Stack, Typography, CardContent } from '@mui/material';
import Card from '@mui/material/Card';

const ChargeLoadingCard = ({ title, subtitle }) => (
    <Card elevation={0}>
        <CardContent>
            <Stack spacing={2} alignItems="center" sx={{ py: 4 }}>
                <CircularProgress size={48} thickness={4} />
                <Typography variant="h6" align="center">{title}</Typography>
                <Typography variant="body2" align="center" color="text.secondary">{subtitle}</Typography>
            </Stack>
        </CardContent>
    </Card>
);

export default ChargeLoadingCard;
